if (!customElements.get('sort-by-select')) {
  class SortBySelect extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.documentClickHandler = this.documentClickHandler.bind(this);
      this.init();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClickHandler);
    }

    init() {
      if(this.classList.contains('filter-form')) {
        document.addEventListener('click', this.documentClickHandler);
      }
      
      [...this.querySelectorAll('.sort-group input[type="radio"]')].forEach(element => {
        ["keydown", "click"].forEach(event => {
          element.addEventListener(event, (e) => {
            if (window.lockClick) return;

            if (event === 'keydown') {
              window.lockClick = true;
              setTimeout(() => {
                window.lockClick = false;
              }, 100);
              if (e.key !== 'Enter' || e.key !== ' ') return;
            }

            // temporarily save sort_by value in session storage
            if (e.target.value === 'manual' || e.target.value === '') {
              window.sessionStorage.removeItem('sort_by');
            } else {
              window.sessionStorage.setItem('sort_by', e.target.value);
            }
            document.dispatchEvent(new CustomEvent('sort_by_changed', { detail: e.target.value }));

            if(!this.classList.contains('filter-form')) return;
            
            this.querySelector('.sort-group').removeAttribute('open');
            document.querySelector('#filterForm').closest('filter-facets').submit();
            this.querySelector('.filter-group-toggle span:nth-child(2)').textContent = this.querySelector('.sort-group input[type="radio"]:checked ~ span').textContent;
          });
        });
      });
    }

    documentClickHandler(e) {
      if(e.target.closest('.sort-group') != null) return;
      this.querySelector('.sort-group').removeAttribute('open');
    }
  }
  customElements.define('sort-by-select', SortBySelect);
}

function setCookie(name, value, days) {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}
